<template>
  <div class="box preview-box">
    <h3 class="mb-5">Preview</h3>
    <div class="mockup">
      <div class="mockup-header">
        <img :src="adData.logo" alt="Promxa Logo" class="logo" />
      </div>

      <div class="mockup-profile-row my-3">
        <img :src="accountToShow.avatar" alt="avatar" class="profile" />
        <div class="name-row">
          <span class="account-name">{{ accountToShow.name }}</span>
          <span class="dots">...</span>
        </div>
      </div>

      <div class="mockup-content">
        <p class="text">
          <span class="link-text">
            {{ truncatedCaption }}
          </span>
          <span class="more" v-if="showMore">See more</span>
        </p>

        <div class="mockup-media">
          <video
            v-if="adData.mediaType === 'video'"
            :src="adData.media"
            controls
            autoplay
            muted
            playsinline
            class="responsive-media"
          ></video>

          <img
            v-else
            :src="adData.media"
            alt="Preview fallback"
            class="responsive-media"
          />

          <div class="cta-overlay">{{ store.ad_call_to_action_type }}</div>
        </div>
      </div>

      <div class="mockup-footer">
        <div class="footer-grid">
          <span class="site">WEBSITENAME.COM</span>
          <p class="headline">{{ adData.headline }}</p>
        </div>
      </div>

      <div class="mockup-icons">
        <img src="@/components/SuperApp/TestPrivew/heart.svg" alt="heart" />
        <img src="@/components/SuperApp/TestPrivew/msg.svg" alt="comment" />
        <img src="@/components/SuperApp/TestPrivew/heart.svg" alt="send" />
      </div>
    </div>
  </div>
</template>

<script>
import logox from "@/components/SuperApp/TestPrivew/logox.jpg";
import postImage from "@/components/SuperApp/TestPrivew/PostImages.jpg";
import profileImage from "@/components/SuperApp/TestPrivew/ProfilePicture.jpg";
import { useSuperAddStore } from "@/store/superAddStore";

export default {
  name: "AdPreviewBox",
  computed: {
    store() {
      return useSuperAddStore();
    },
    adData() {
      const fallbackImage = postImage;

      const file = this.store.adCreativeData?.videoFile;
      let mediaUrl = null;
      let mediaType = "image";

      if (file) {
        const type = file.type;
        if (type.includes("video")) {
          mediaUrl = URL.createObjectURL(file); // ← هنا التحويل
          mediaType = "video";
        } else if (type.includes("image")) {
          mediaUrl = URL.createObjectURL(file);
          mediaType = "image";
        }
      }

      return {
        logo: logox,
        profileImage: profileImage,
        name: "Verto",
        caption: this.store.adCreativeData?.caption || "Default caption...",
        headline: this.store.adCreativeData?.headline || "Headline copy here",
        media: mediaUrl || fallbackImage,
        mediaType,
      };
    },
    truncatedCaption() {
      return this.adData.caption.length > 100
        ? this.adData.caption.slice(0, 100)
        : this.adData.caption;
    },
    showMore() {
      return this.adData.caption.length > 100;
    },
    accountToShow() {
      const defaultAccount = {
        name: "Promxa Account",
        avatar: profileImage,
      };

      const store = useSuperAddStore();
      const accounts = store.selectedAccounts || {};

      const firstValid = Object.values(accounts).find((acc) => acc && acc.id);

      return firstValid || defaultAccount;
    },
  },
};
</script>

<style scoped>
.preview-box {
  width: 100%;
  max-width: 407px;
  margin: auto;
  padding: 2rem;
  box-shadow: 0px 2px 12px rgba(102, 102, 102, 0.12);
  border-radius: 12px;
}

.mockup {
  border: 2px solid #207878;
  border-radius: 16px;
  overflow: hidden;
  background: white;
  font-size: 14px;
  box-shadow: 0px 2px 12px rgba(102, 102, 102, 0.12);
  display: flex;
  flex-direction: column;
}

.mockup-header {
  padding: 1rem 1rem 0 1rem;
}

.logo {
  height: 18px;
  max-width: 100%;
}

.mockup-profile-row {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem;
  padding-top: 0.5rem;
  background-color: #f6f9fa;
}

.profile {
  width: 35px;
  height: 35px;
  border-radius: 50%;
}

.name-row {
  display: flex;
  justify-content: space-between;
  width: 100%;
  font-weight: 500;
  color: #222;
}

.dots {
  margin-left: auto;
  padding-right: 0.5rem;
}

.mockup-content {
  padding: 0 1rem;
}

.text {
  color: #333;
  margin-bottom: 0.75rem;
  font-size: 13px;
}

.link-text {
  display: inline;
}

.mockup-media {
  position: relative;
  width: 100%;
  margin-bottom: 0.75rem;
}

.mockup-media img {
  width: 100%;
  height: auto;
  border-radius: 4px;
}

.cta-overlay {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  background: white;
  color: #207878;
  font-size: 13px;
  font-weight: 600;
  border: 1px solid #ccc;
  border-radius: 16px;
  padding: 4px 12px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.mockup-footer {
  margin-bottom: 0.5rem;
}

.footer-grid {
  display: grid;
  background: linear-gradient(to right, #439597, #318086);
  padding: 0.5rem 1rem;
  color: white;
}

.site {
  font-size: 11px;
  text-transform: uppercase;
}

.headline {
  font-size: 13px;
  font-weight: 600;
}

.more {
  color: #666;
  font-size: 12px;
}

.mockup-icons {
  padding: 0 1rem;
  font-size: 16px;
  display: flex;
  gap: 1rem;
  color: #444;
  margin-bottom: 1rem;
}

.mockup-icons img {
  width: 18px;
  height: 18px;
}

/* Media Query for Small Screens */
@media (max-width: 480px) {
  .preview-box {
    padding: 0.5rem;
  }

  .mockup {
    font-size: 12px;
  }

  .cta-overlay {
    font-size: 12px;
    padding: 3px 10px;
  }

  .profile {
    width: 30px;
    height: 30px;
  }

  .headline {
    font-size: 12px;
  }

  .site {
    font-size: 10px;
  }

  .mockup-icons img {
    width: 16px;
    height: 16px;
  }
}
.responsive-media {
  width: 100%;
  height: auto;
  max-height: 300px;
  border-radius: 8px;
  object-fit: cover;
}
</style>
